import { MentiError } from '@mentimeter/error-utils/error';

export class NoInteractiveContentError extends MentiError {
  constructor() {
    const message = 'Slide does not have interactive content';
    super(message, {
      feature: 'compatibility-layer',
      tags: {
        migrated: true,
      },
    });
    this.name = 'NoInteractiveContentError';
  }
}
